module.exports = __webpack_public_path__ + "img/message.3bc809a.png";